import { DatePicker, TimeRangePickerProps, } from "@basic-components";
import dayjs from "dayjs";
import { FC } from "react";

const OriginDateRangePicker = DatePicker.RangePicker;

const getDate = (valueType: 'string' | 'array' | 'long', splitChar: string, date?: any,) => {
    if (!date) return [];
    if (valueType === 'array' || Array.isArray(date)) return date;

    return (date as string).split(splitChar);
};

interface DateRangePickerProps extends Omit<TimeRangePickerProps, 'value'|'onChange'> {
    value?: Array<string> | string | number;
    onChange?: (range: Array<string> | string) => void;
    valueType?: 'string' | 'array' | 'long';
    format?: string;
    splitChar?: string;
    isView?: boolean;
}
export const DateRangePicker: FC<DateRangePickerProps> = ({value, format='YYYY-MM-DD', onChange, valueType='long', splitChar=',', isView, ...props}) => {
  const dates = getDate(valueType, splitChar, value);

  const [formattedStartDate, formattedEndDate] = dates
    .filter((date: string|number) => date)
    .map((date: string|number) => {
        if (typeof date === 'number') return dayjs(date);
        return dayjs(date, format as string)
    });

    const handleChange = (dates: any) => {
        const [formattedStartDate, formattedEndDate] = dates || [];
        const startDate = valueType === 'long' ? formattedStartDate?.valueOf() : formattedStartDate?.format(format);
        const endDate = valueType === 'long' ? formattedEndDate?.valueOf() : formattedEndDate?.format(format);
        onChange?.(['array', 'long'].includes(valueType) ? [startDate, endDate] : `${startDate},${endDate}`);
    };


    if (isView) return dates.every((date: string) => date) 
        ? valueType === 'long' ? 
    `${dayjs(formattedStartDate).format(format)} ~ ${dayjs(formattedEndDate).format(format)}`
    :`${dates[0]} ~ ${dates[1]}` : '--';
    return (
        <OriginDateRangePicker
         {...props}
         value={[formattedStartDate, formattedEndDate]}
          onChange={handleChange} />
    );
};